import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { AUTH_LOGIN } from "../../../Config/firebase";
import { googleSignInMessage, shouldShowLinkGoogleCard } from "../../../Utils/panelAdminAccess";
import { linkGoogleToCurrentAdmin } from "../../../Utils/panelAdminSession";

const LinkGoogleCard = () => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return AUTH_LOGIN.onAuthStateChanged((next) => {
      setUser(next);
      setReady(true);
    });
  }, []);

  if (!ready || !shouldShowLinkGoogleCard(user)) return null;

  const handleLink = async () => {
    setLoading(true);
    try {
      const linkedUser = await linkGoogleToCurrentAdmin(user);
      setUser(linkedUser);
      toast.success("Google vinculado nesta conta.");
    } catch (error) {
      toast.error(googleSignInMessage(error && error.code) || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        mb: 3,
        p: 2,
        borderRadius: 2,
        bgcolor: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <Typography sx={{ color: "#fff", fontWeight: 600, mb: 0.5 }}>
        Vincular Google
      </Typography>
      <Typography sx={{ color: "rgba(255,255,255,0.72)", mb: 2, fontSize: 14 }}>
        Liga o Google nesta mesma conta. A senha do painel continua ativa.
      </Typography>
      <Button
        type="button"
        disabled={loading || !user}
        onClick={handleLink}
        sx={{
          borderRadius: "15px",
          border: "1px solid #2af598",
          color: "#fff",
          textTransform: "none",
          fontWeight: 500,
        }}
      >
        Vincular Google
      </Button>
    </Box>
  );
};

export default LinkGoogleCard;
